export const getTotalSeatCount = (seats = []) => {
    if (!Array.isArray(seats)) return 0;

    return seats.reduce((total, item) => {
        return total + (item?.count * item?.qty || 0);
    }, 0);
};
